/**
 * Datatable Props Helper
 * 
 * Creates a props object wrapping datatable handler functions from utils/helpers.
 * Binds handlers to current table state parameters (filters, search, pagination, etc).
 * Provides unified props interface for passing to datatable child components.
 * 
 * @param {Object} params - Parameter object with table state (dispatch, state, collection, etc)
 * @returns {Object} Props object with bound handler functions
 */

import {
  changeFilters,
  closeAlert,
  closeExpandCard,
  closeMoreInfoCard,
  enterSearch,
  getCompanyDetails,
  handleData,
  openExpandCard,
  resetFilter,
  resetSearch,
  resetTable,
  submitSearch,
  unhideFields,
} from "../../../utils/helpers";

export const props = (params) => {
  return {
    ...params,
    closeExpandCard: () => closeExpandCard(params),
    closeMoreInfoCard: () => closeMoreInfoCard(params),
    changeFilters: (e) => {
      changeFilters(e, params);
    },
    enterSearch: (e) => {
      enterSearch(e, params);
    },
    submitSearch: (e) => {
      submitSearch(e, params);
    },
    resetSearch: (e) => {
      resetSearch(e, params);
    },
    resetFilter: (e) => {
      resetFilter(e, params);
    },
    resetTable: (e) => {
      resetTable(e, params);
    },
    unhideFields: () => unhideFields(params),
    handleData: (e) => {
      handleData(e, params);
    },
    getCompanyDetails: (e) => {
      getCompanyDetails(e, params);
    },
    openExpandCard: (e) => {
      openExpandCard(e, params);
    },
    closeAlert: () => {
      closeAlert(params);
    },
  };
};
